// SEO helpers shared across storefront metadata, sitemap and JSON-LD.

function protocolFor(host: string): string {
	// Localhost stays http; everything else assumes https in production.
	return host.startsWith("localhost") || host.startsWith("127.0.0.1") ? "http" : "https";
}

export function absoluteUrl(host: string, path: string): string {
	if (!host) return path;
	const clean = path.startsWith("/") ? path : `/${path}`;
	return `${protocolFor(host)}://${host}${clean}`;
}

export function absoluteMediaUrl(
	host: string,
	path: string | null | undefined,
): string | undefined {
	if (!path) return undefined;
	if (path.startsWith("http")) return path;
	return absoluteUrl(host, path);
}

/** Render a JSON-LD <script> payload string (escaped for safe injection). */
export function jsonLd(data: unknown): string {
	return JSON.stringify(data).replace(/</g, "\\u003c");
}
